module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-input-number",
    class: _vm.classes
  }, [_c('el-input-number', _vm._g(_vm._b({
    attrs: {
      "min": 0
    }
  }, 'el-input-number', _vm.$attrs, false), _vm.$listeners))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9fd7e3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/inputNumber/rtInputNumber.vue
// module id = 1535
// module chunks = 91